import { useDispatch } from "react-redux";

import { setIsMidstreamNavigatorFilter as setIsMidstreamNavigatorFacilityFilter } from "../../../store/features/filter/facilityFilterSlice";
import { setIsMidstreamNavigatorFilter } from "../../../store/features/filter/filterSlice";
import { WellNetworkRequest } from "./useGetWellNetworkMap";

interface UseShowWellToFacilityNetworkProps {
  wellNetworkMapRequest: WellNetworkRequest;
  setWellNetworkMapRequest: React.Dispatch<React.SetStateAction<WellNetworkRequest>>;
  setNetworkMapCleared?: React.Dispatch<React.SetStateAction<boolean>>;
}

interface UseShowWellToFacilityNetworkReturn {
  showWellToFacilityNetwork: (idValue: string) => void;
}

/**
 * Custom hook that encapsulates the "Show Well To Facility Network" functionality
 * Used by both FacilityHighlighter (context menu) and FilterButton (toolbar button)
 */
export function useShowWellToFacilityNetwork({
  wellNetworkMapRequest,
  setWellNetworkMapRequest,
  setNetworkMapCleared
}: UseShowWellToFacilityNetworkProps): UseShowWellToFacilityNetworkReturn {
  const dispatch = useDispatch();

  const showWellToFacilityNetwork = (idValue: string) => {
    // Set midstream navigator flags (same as both components)
    dispatch(setIsMidstreamNavigatorFilter(true));
    dispatch(setIsMidstreamNavigatorFacilityFilter(true));

    // Clear network map if setter is provided
    if (setNetworkMapCleared) {
      setNetworkMapCleared(false);
    }

    // Set the well network map request with the provided ID
    // Both wells and facilities use the wellIds field
    setWellNetworkMapRequest({
      ...wellNetworkMapRequest,
      wellIds: [idValue]
    });
  };

  return {
    showWellToFacilityNetwork
  };
}
